import React from 'react';
import Component from '@/components/ui/etheral-shadow';

const DemoOne = () => {
  return (
    <div className="flex w-full h-screen justify-center items-center bg-white">
      <div className="w-full h-[80vh] max-w-6xl">
        <Component
          color="rgba(200, 200, 200, 1)"
          animation={{ scale: 100, speed: 90 }}
          noise={{ opacity: 1, scale: 1.2 }}
          sizing="fill"
        />
      </div>
    </div>
  );
};

export { DemoOne };

